import { RolexImage } from './Image'
import { RolexQuote } from './Quote'
import { RolexTextBlock } from './TextBlock'
import { RolexVideo } from './video'
import { cn } from '@lib/cn'
import { Item } from '@lib/kontent'
import { RolexImage as RolexImageModel } from '@lib/kontent/models/RolexImage'
import { RolexQuoteBlock } from '@lib/kontent/models/RolexQuoteBlock'
import { RolexTextBlock as RolexTextBlockModel } from '@lib/kontent/models/RolexTextBlock'
import { RolexVideo as RolexVideoModel } from '@lib/kontent/models/RolexVideo'
import React, { FC } from 'react'

export type SupportedContentBlocks = Item<
  RolexImageModel | RolexTextBlockModel | RolexVideoModel | RolexQuoteBlock
>

type RolexContentBlocksProps = {
  className?: string
  items: SupportedContentBlocks[]
}

export const RolexContentBlocks: FC<RolexContentBlocksProps> = ({ className, items }) => {
  return (
    <div className={cn('py-[60px] md:py-[90px]', className)}>
      {items.map((block) => {
        if (block?.system?.type === 'rolex_video') {
          const elements = block.elements as RolexVideoModel
          return (
            <RolexVideo
              key={block.system.id}
              youtubeVideoId={elements.youtube_video_id.value}
              placeholderImage={elements.placeholder_image}
            />
          )
        }

        if (block?.system?.type === 'rolex_image') {
          const elements = block.elements as RolexImageModel
          return (
            <RolexImage
              key={block.system.id}
              mobileImage={elements.mobile_image}
              desktopImage={elements.desktop_image}
              size={elements.size.value[0]?.codename as string}
            />
          )
        }

        if (block?.system?.type === 'rolex_text_block') {
          const elements = block.elements as RolexTextBlockModel
          return (
            <RolexTextBlock
              key={block.system.id}
              title={elements.title.value}
              description={elements.description.value}
              headingTag={elements.heading_tag.value[0]?.codename || 'h3'}
              buttonLink={elements.button_link__optional_.value}
              buttonTitle={elements.button_title__optional_.value}
              displayRolexPlaque={
                elements.display_rolex_plaque.value[0]?.codename === 'yes' || false
              }
            />
          )
        }

        if (block?.system?.type === 'rolex_quote_block') {
          const elements = block.elements as RolexQuoteBlock
          return (
            <RolexQuote
              key={block.system.id}
              author={elements.author.value}
              quote={elements.quote.value}
            />
          )
        }

        return null
      })}
    </div>
  )
}
